module.exports = __webpack_public_path__ + "img/jituan_zizhi.26beaae9.png";